export enum TipologiaDomanda {
    radio = 'radio',
    checkbox = 'checkbox',
    aperta = 'aperta'
}